module.exports = __webpack_public_path__ + "23_tiis.jpg?088ab8d9818905cf9e8452d16ddae2e3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/23_tiis.jpg
// module id = 205
// module chunks = 0